import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class SalesDespatchNoteStatusReferenceService extends BaseReferenceService {
  constructor() {
    super('SalesDespatchNoteStatusReference');
  }
}
